// MockPaperStyle — per-paper generation strategy for mock exams.
//
// Decision (Session 19S · CONTENT_SPEC §M):
//   3 styles. User can mix freely across the (≤3) papers — e.g. paper 1 strict,
//   paper 2 inspired, paper 3 content_based.
//
//   Semantics:
//     past_paper_strict   — strictly mirror past paper's question count, type
//                           distribution, style, difficulty curve. Question
//                           CONTENT comes from this course's cases (not copied
//                           from the past paper — copying defeats training).
//     past_paper_inspired — reference past paper style/tone but AI generates
//                           freely on count and depth.
//     content_based       — no past paper required; AI generates per case
//                           content + Bloom distribution (default for users
//                           with no past paper).
//
//   past_paper_strict / past_paper_inspired REQUIRE pastPaperRef on
//   MockPaperSpec. Validated at MockPaperSpecSchema level (refine).
import { z } from 'zod';
export const MockPaperStyleSchema = z.enum([
    'past_paper_strict',
    'past_paper_inspired',
    'content_based',
]);
export const ALL_MOCK_PAPER_STYLES = MockPaperStyleSchema.options;
export const DEFAULT_MOCK_PAPER_STYLE = 'content_based';
/** Whether this style requires a pastPaperRef on its MockPaperSpec. */
export function styleRequiresPastPaper(style) {
    return style === 'past_paper_strict' || style === 'past_paper_inspired';
}
//# sourceMappingURL=mock-paper-style.js.map